import { useLayoutEffect, useRef, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";

import { useGet } from "hooks/query";
import { endpoints } from "services/endpoints";
import useSearch from "hooks/useSearch/useSearch";
// i18n
import { useTranslation } from "react-i18next";
import Modal from "components/Modal/Modal";
import useGetSingleData from "hooks/useGetSingleData/useGetSingleData";
import ModalForm from "./ModalForm";
import Table from "./Table/Table";

const WareHouse = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  let [searchParams, _] = useSearchParams();
  let queryId = searchParams.get("row_id");
  const { id } = useParams();
  const modal = useRef();
  const { searchResult, handleSearch } = useSearch();

  const handleTemplatesModal = (value) => {
    modal.current.openModal(value);
  };

  const { data, isLoading, isError, refetch } = useGet({
    link: endpoints.warehouse.get,
    params: { org_id: id, size: 10, page: page + 1, q: searchResult || undefined },
  });
  const { singleData } = useGetSingleData(queryId, data?.data);

  useLayoutEffect(() => {
    if (queryId && modal.current) {
      handleTemplatesModal(true);
    }
  }, [queryId]);

  const paginationConfig = {
    forcePage: page,
    total: data?.total,
    pageCount: Math.ceil((data?.total ?? 10) / 10),
    pageRangeDisplayed: 2,
    onPageChange: ({ selected }) => setPage(selected % data?.total),
  };

  if (isLoading) return <p>Loading</p>;
  if (isError) return <p>Errror</p>;

  return (
    <div className="flex h-full flex-col gap-y-2">
      <Table
        data={data.data}
        setPage={setPage}
        refetch={refetch}
        modalToggler={handleTemplatesModal}
        handleSearch={handleSearch}
        paginationConfig={paginationConfig}
      />
      <Modal ref={modal} title={queryId ? t("pages.warehouses.change") : t("pages.warehouses.create")}>
        <ModalForm
          close={handleTemplatesModal}
          refetch={refetch}
          row={queryId && singleData ? singleData : {}}
          orgId={id}
        />
      </Modal>
    </div>
  );
};

export default WareHouse;
